import MiniCalendar from './MiniCalendar'

export default MiniCalendar
